
/**
 *     Data-driven UI for JSON models for views, page layout, and APIs
 *
 *     @author Irina Patrikeeva <irina.i.ipatrikeeva@nasa.gov>
 *
 *     Created on 06/07/2017
 *     Modified on 06/11/2018
 *
 */

/**********************************
 * API models : default and custom
 **********************************/

/**
 * JSON model for the part APIs
 */
var RecordAPIModel = {
    "properties": [
        {
            "page": "record", // page name
            "properties": [
                {
                    "name": "metadata", // data name for a section of a page
                    "url" : [ App.globalState.searchAPIBase + "/document/", "/", "?alias="], // url to get the data
                    "parameters": [ "type", "id", "alias" ] // url parameters
                },
                {
                    "name": "links",
                    "url" : [ App.globalState.searchAPIBase + "/links/", "/", "/", "?=&page=", "&alias=" ],
                    "parameters": [ "_index", "_type", "_id", "linksPageNumber", "alias" ],
                    "dependsOn": [ "metadata" ]
                }
            ]
        }
    ]
};

/**
 * JSON model for the part APIs
 */
var PartAPIModel = {
    "properties": [
        {
            "page": "record", // page name
            "properties": [
                {
                    "name": "metadata", // data name for a section of a page
                    "url" : [ App.globalState.searchAPIBase + "/document/", "/", "?alias="], // url to get the data
                    "parameters": [ "type", "id", "alias" ] // url parameter
                },
                {
                    "name": "parents",
                    "url" : [ App.globalState.searchAPIBase + "?type=", "&filters=bill.sarahEdiId:eq:", "&sort=", "&order=", "&page=", "&alias=" ],
                    "parameters": [ "type", "id", "sortField", "sortOrder", "page", "alias" ]
                },
                {
                    "name": "siblings",
                    "url" : [ App.globalState.searchAPIBase + "?type=", "&filters=drawingNumber:eq:", "&sort=", "&order=", "&page=", "&alias=" ],
                    "parameters": [ "type", "drawingNumber", "sortField", "sortOrder", "page", "alias" ],
                    "dependsOn": [ "metadata" ] // data name url depends on [optional]
                },
                {
                    "name": "components",
                    "url": [ App.globalState.searchAPIBase + "?type=component&filters=masterEdiId:eq:", "&sort=", "&order=", "&page=", "&alias=" ],
                    "parameters": [ "id", "sortField", "sortOrder", "page", "alias" ],
                    "model": "component"
                },
                {
                    "name": "documents",
                    "url": [ App.globalState.searchAPIBase + "/links/hardwaredata/", "/", "?=&page=", "&sort=", "&order=", "&alias=" ],
                    "parameters": [ "type", "id", "page", "sortField", "sortOrder", "alias" ],
                    "multiple": true,
                    "model": [ "fmea", "hazard", "praca", "ifi" ]
                }
            ]
        }
    ]
};

/**
 * JSON model for the part APIs
 */
var EMUPartAPIModel = {
    "properties": [
        {
            "page": "record", // page name
            "properties": [
                {
                    "name": "metadata", // data name for a section of a page
                    "url" : [ App.globalState.searchAPIBase + "/document/", "/", "?alias="], // url to get the data
                    "parameters": [ "type", "id", "alias" ] // url parameter
                },
                {
                    "name": "parents",
                    "url" : [ App.globalState.searchAPIBase + "?type=", "&filters=bill.sarahEdiId:eq:", "&sort=", "&order=", "&page=", "&alias=" ],
                    "parameters": [ "type", "id", "sortField", "sortOrder", "page", "alias" ]
                },
                {
                    "name": "siblings",
                    "url" : [ App.globalState.searchAPIBase + "?type=", "&filters=drawingNumber:eq:", "&sort=", "&order=", "&page=", "&alias=" ],
                    "parameters": [ "type", "drawingNumber", "sortField", "sortOrder", "page", "alias" ],
                    "dependsOn": [ "metadata" ] // data name url depends on [optional]
                },
                {
                    "name": "components",
                    "url": [ App.globalState.searchAPIBase + "?type=emucomponent&filters=masterEdiId:eq:", "&sort=", "&order=", "&page=", "&alias=" ],
                    "parameters": [ "id", "sortField", "sortOrder", "page", "alias" ],
                    "model": "emucomponent"
                },
                {
                    "name": "documents",
                    "url": [ App.globalState.searchAPIBase + "/links/emupart/", "/", "?=&page=", "&sort=", "&order=", "&alias=" ],
                    "parameters": [ "type", "id", "page", "sortField", "sortOrder", "alias" ],
                    "multiple": true,
                    "model": [ "fmea", "hazard", "praca", "ifi" ]
                }
            ]
        }
    ]
};
/**
 * JSON model for component APIs
 * @type {{}}
 */
var ComponentAPIModel = {
    "properties": [
        {
            "page": "record", // page name
            "properties": [
                {
                    "name": "metadata", // data name for a section of a page
                    "url" : [ App.globalState.searchAPIBase + "/document/", "/", "?alias="], // url to get the data
                    "parameters": [ "type", "id", "alias" ] // url parameters
                },
                {
                    "name": "parents",
                    "url" : [ App.globalState.searchAPIBase + "?type=", "&filters=bill.sarahEdiId:eq:", "&sort=", "&order=", "&page=", "&alias=" ],
                    "parameters": [ "type", "id", "sortField", "sortOrder", "page", "alias" ]
                },
                {
                    "name": "siblings",
                    "url" : [ App.globalState.searchAPIBase + "?type=", "&filters=masterEdiId:eq:", "&sort=", "&order=", "&page=", "&alias=" ],
                    "parameters": [ "type", "masterEdiId", "sortField", "sortOrder", "page", "alias" ],
                    "dependsOn": [ "metadata" ]
                },
                {
                    "name": "part",
                    "url": [ App.globalState.searchAPIBase + "/document/part/", "?alias=" ],
                    "parameters": [ "masterEdiId", "alias" ],
                    "dependsOn": [ "metadata" ],
                    "model": "part"
                },
                {
                    "name": "events",
                    "url": [ App.globalState.searchAPIBase + "?filters=bill.sarahEdiId|eq|", "&type=event&page=", "&sort=", "&order=", "&alias=" ],
                    "parameters": [ "id", "page",  "sortField", "sortOrder", "alias" ],
                    "model": "event"
                },
                {
                    "name": "documents",
                    "url": [ App.globalState.searchAPIBase + "/links/hardwaredata/", "/", "?=&page=", "&sort=", "&order=", "&alias=" ],
                    "parameters": [ "type", "id", "page", "sortField", "sortOrder", "alias" ],
                    "multiple": true,
                    "model": [ "dr", "ec", "fab", "fiar", "od", "odt", "tps", "waiver", "ytn" ]
                }
            ]
        }
    ]
};

/**
 * JSON model for EMU component APIs
 * @type {{}}
 */
var EMUComponentAPIModel = {
    "properties": [
        {
            "page": "record", // page name
            "properties": [
                {
                    "name": "metadata", // data name for a section of a page
                    "url" : [ App.globalState.searchAPIBase + "/document/", "/", "?alias="], // url to get the data
                    "parameters": [ "type", "id", "alias" ] // url parameters
                },
                {
                    "name": "parents",
                    "url" : [ App.globalState.searchAPIBase + "?type=", "&filters=bill.sarahEdiId:eq:", "&sort=", "&order=", "&page=", "&alias=" ],
                    "parameters": [ "type", "id", "sortField", "sortOrder", "page", "alias" ]
                },
                {
                    "name": "siblings",
                    "url" : [ App.globalState.searchAPIBase + "?type=", "&filters=masterEdiId:eq:", "&sort=", "&order=", "&page=", "&alias=" ],
                    "parameters": [ "type", "masterEdiId", "sortField", "sortOrder", "page", "alias" ],
                    "dependsOn": [ "metadata" ]
                },
                {
                    "name": "part",
                    "url": [ App.globalState.searchAPIBase + "/document/emupart/", "?alias=" ],
                    "parameters": [ "masterEdiId", "alias" ],
                    "dependsOn": [ "metadata" ],
                    "model": "emupart"
                },
                {
                    "name": "events",
                    "url": [ App.globalState.searchAPIBase + "?filters=bill.sarahEdiId|eq|", "&type=emuevent&page=", "&sort=", "&order=", "&alias=" ],
                    "parameters": [ "id", "page",  "sortField", "sortOrder", "alias" ],
                    "model": "emuevent"
                },
                {
                    "name": "documents",
                    "url": [ App.globalState.searchAPIBase + "/links/emucomponent/", "/", "?=&page=", "&sort=", "&order=", "&alias=" ],
                    "parameters": [ "type", "id", "page", "sortField", "sortOrder", "alias" ],
                    "multiple": true,
                    "model": [ "emudr", "emuec", "emufab", "emufiar", "emuod", "emuodt", "emutps", "emuwaiver", "emuytn" ]
                }
            ]
        }
    ]
};

/*************************************
 * Layout models : default and custom
 *************************************/

/**
 * JSON model for default layout model for record page
 */
var RecordLayoutModel = {
    "properties": [
        {
            "page": "record",  // page name
            "template": "#viewer-layout", // "template" is outer page template id inside which page layout regions are rendered
            "regions": [
                { "name": "headerRegion", "el": "#header-region" },
                { "name": "recordRegion", "el": "#record-region" },
                { "name": "linksRegion", "el": "#links-region" }
            ]
        }
    ]
};


/**
 * JSON model representing Backbone.Marionette.LayoutViews for a part page layout
 */
var PartLayoutModel = {
    "properties": [
        {
            "page": "record",  // page name
            "template": "#viewer-layout", // "template" is outer page template id inside which page layout regions are rendered
            "regions": [
                {
                    "name": "headerRegion", // region name (page section name)
                    "el": "#header-region" // region unique id (created dynamically)
                },
                { "name": "treeRegion", "el": "#tree-region" },
                { "name": "accordionRegionGeneral", "el": "#accordion-region-general" },
                { "name": "accordionRegionAttributes", "el": "#accordion-region-attributes" },
                { "name": "accordionRegionLimitedLife", "el": "#accordion-region-limitedLife" },
                { "name": "tableHeaderRegionParents", "el": "#table-header-region-parents" },
                { "name": "tableRegionParents", "el": "#table-region-parents" },
                { "name": "tableHeaderRegionSiblings", "el": "#table-header-region-siblings" },
                { "name": "tableRegionSiblings", "el": "#table-region-siblings" },
                { "name": "tableHeaderRegionChildren", "el": "#table-header-region-children" },
                { "name": "tableRegionChildren", "el": "#table-region-children" },
                { "name": "tableHeaderRegionComponents", "el": "#table-header-region-components" },
                { "name": "tableRegionComponents", "el": "#table-region-components" },
                { "name": "tableHeaderRegionLinks", "el": "#table-header-region-documents" },
                { "name": "tableRegionLinks", "el": "#table-region-documents" }
            ]
        }
    ]
};

/**
 * JSON model representing Backbone.Marionette.LayoutViews for a component page layout
 * @type {{}}
 */
var ComponentLayoutModel = {
    "properties": [
        {
            "page": "record",  // page name
            "template": "#viewer-layout", // "template" is outer page template id inside which page layout regions are rendered
            "regions": [
                {
                    "name": "headerRegion", // region name (page section name)
                    "el": "#header-region" // region unique id (created dynamically)
                },
                { "name": "treeRegion", "el": "#tree-region" },
                { "name": "accordionRegionGeneral", "el": "#accordion-region-general" },
                { "name": "accordionRegionAttributes", "el": "#accordion-region-attributes" },
                { "name": "accordionRegionLimitedLife", "el": "#accordion-region-limitedLife" },
                { "name": "accordionRegionPart", "el": "#accordion-region-part" },
                { "name": "tableHeaderRegionParents", "el": "#table-header-region-parents" },
                { "name": "tableRegionParents", "el": "#table-region-parents" },
                { "name": "tableHeaderRegionSiblings", "el": "#table-header-region-siblings" },
                { "name": "tableRegionSiblings", "el": "#table-region-siblings" },
                { "name": "tableHeaderRegionChildren", "el": "#table-header-region-children" },
                { "name": "tableRegionChildren", "el": "#table-region-children" },
                { "name": "tableHeaderRegionComponents", "el": "#table-header-region-components" },
                { "name": "tableRegionComponents", "el": "#table-region-components" },
                { "name": "tableHeaderRegionLinks", "el": "#table-header-region-documents" },
                { "name": "tableRegionLinks", "el": "#table-region-documents" },
                { "name": "tableHeaderRegionEvents", "el": "#table-header-region-events" },
                { "name": "tableRegionEvents", "el": "#table-region-events" }
            ]
        }
    ]
};

/***********************************
 * View models : default and custom
 ***********************************/

/**
 * JSON model for a default single page record view. Generated by the app.
 * If custom view model doesn't exist in the Data Registry, this view model is used.
 */
var RecordViewModel = {
    "properties": [
        {
            "page": "record", // page name
            "template": "#default-layout-template",
            "regions": [
                {
                    "name": "headerRegion", // matches one of the region names in the LayoutModel
                    "template": "#header-template", // matches one of the existing templates
                    "fields": [
                        {
                            "data": "metadata", // "data" field matches one of the names in the APIModel
                            "names": [ "title", "_type", "source", "url", "_id", "all" ] // Field "names" match field names in the data JSON model
                        }
                    ],
                    "viewType": "ItemView" // Backbone.Marionette view type (ItemView renders a model)
                },
                {
                    "name": "recordRegion",
                    "template": "#record-region",
                    "fields": [
                        {
                            "data": "metadata",
                            "names": [ "all" ]
                        }
                    ],
                    "default": "true",
                    "model": {
                        "template": '#panel-body-template',
                        "viewType": "CompositeView",
                        "childViewContainer": ".panel-body",
                        "nested": "true",
                        "childView": {
                            "template": "#panel-child-template",
                            "tagName": "div",
                            "className": "full-row record-row",
                            "viewType": "ItemView"
                        },
                        "childViewMultiple": {
                            "template": "#panel-multiple-child-template",
                            "tagName": "div",
                            "className": "full-row record-item",
                            "viewType": "ItemView"
                        }
                    }

                },
                {
                    "name": "linksRegion",
                    "template": "#links-region",
                    "fields": [
                        {"data": "links", "names": ["total"]}
                    ],
                    "dependsOn": ["metadata"], // matches "dependsOn" field in API JSON model
                    "viewType": "ItemView",
                    "default": "true",
                    "table": "true"
                }
            ]
        }
    ]
};

/**
 * JSON model representing Backbone.Marionette views and what data to render in what region and template for Part records
 */
var PartViewModel = {
    "properties": [
        {
            "page": "record", // page name
            "regions": [
                {
                    "name": "headerRegion", // matches one of the region names in the LayoutModel
                    "template": "#custom-header-template", // matches one of the existing templates
                    "fields": [
                        {
                            "data": "metadata", // "data" field matches one of the names in the APIModel
                            "names": [ "_type", "title", "description" ] // Field "names" match field names in the data JSON model
                        }
                    ],
                    "viewType": "ItemView" // Backbone.Marionette view type (ItemView renders a model)
                },
                {
                    "name": "treeRegion",
                    "template": "#tree-template",
                    "fields": [
                        { "data": "metadata", "names": [ "bill" ] },
                        { "data": "parents", "names": [ "_id", "itemNumber", "title" ] },
                        { "data": "siblings", "names": [ "_id", "itemNumber", "title" ] }
                   ],
                    "viewType": "ItemView",
                    "graph": "true"
                },
                {
                    "name": "accordionRegionGeneral", // TODO: make this the default accordion template
                    "template": "#accordion-template",
                    "fields": [
                        { "data": "metadata", "names": [ "all" ] }
                    ],
                    "viewType": "CompositeView", // CompositeView renders both a collection and a model
                    "nested": "true", // signifies that the data for this region is in a nested object
                    "childViewContainer": ".panel-body",
                    "parentFields": [ // parentFields is the data that is necessary for display but does not come from the JSON Model or the APIModel
                        { "name": "title", "value": "General Information" },
                        { "name": "id", "value": "generalInfo" }
                    ],
                    "childView": { // CompositeView needs a childView (view for models inside the collection)
                        "template": "#accordion-child-template", // child model view template id
                        "tagName": "div", // child model view wrapping element
                        "className": "full-row record-row", // child model wrapping element's class name
                        "viewType": "ItemView" // child model view type
                    },
                    "events": {
                        "click .accordion-button": "performActionOne"
                    },
                    "hash": {
                        "performActionOne": "wrapperAccordionIconClick"
                    }
                },
                {
                    "name": "accordionRegionAttributes",
                    "template": "#accordion-template",
                    "fields": [
                        { "data": "metadata", "names": [ "attributes" ] }
                    ],
                    "viewType": "CompositeView",
                    "nested": "true",
                    "childViewContainer": ".panel-body",
                    "parentFields": [
                        { "name": "title", "value": "Attributes" },
                        { "name": "id", "value": "attributes" }
                    ],
                    "childView": {
                        "template": "#accordion-child-template",
                        "tagName": "div",
                        "className": "full-row record-row",
                        "viewType": "ItemView"
                    },
                    "events": {
                        "click .accordion-button": "performActionOne"
                    },
                    "hash": {
                        "performActionOne": "wrapperAccordionIconClick"
                    }
                },
                {
                    "name": "accordionRegionLimitedLife",
                    "template": "#accordion-template",
                    "fields": [
                        { "data": "metadata", "names": [ "limitedLife" ] }
                    ],
                    "viewType": "CompositeView",
                    "nested": "true",
                    "childViewContainer": ".panel-body",
                    "parentFields": [
                        { "name": "title", "value": "Limited Life" },
                        { "name": "id", "value": "limitedLife" }
                    ],
                    "childView": {
                        "template": "#accordion-child-template",
                        "tagName": "div",
                        "className": "full-row record-row",
                        "viewType": "ItemView"
                    },
                    "events": {
                        "click .accordion-button": "performActionOne"
                    },
                    "hash": {
                        "performActionOne": "wrapperAccordionIconClick"
                    }
                },
                {
                    "name": "tableHeaderRegionParents", // TODO: make this the default table header template
                    "template": "#table-header-template",
                    "fields": [
                        { "data": "metadata", "names": [ "_type" ] },
                        { "data": "parents", "names": [ "total" ] }
                    ],
                    "viewType": "ItemView",
                    "additionalFields": [  // similar to parentFields in regions with a CompositeView, additionalFields is the data that is necessary for display but does not come from the JSON model or API model.
                        { "name": "table_type", "value": "Parents" },
                        { "name": "table_name", "value": "parents" },
                        { "name": "region_name", "value": "tableRegionParents" }, // value must match one of the regions name field
                        { "name": "page", "value": 1},
                        { "name": "start", "value": 1 },
                        { "name": "end", "value": 20 },
                        { "name": "itemsPerPage", "value": 20 }
                    ],
                    "triggers": {
                        "click .page-arrow.previous-page": "action:one",
                        "click .page-arrow.next-page": "action:two"
                    },
                    "events": {
                        "action:one": "performActionOne",
                        "action:two": "performActionTwo"
                    },
                    "hash": {
                        "performActionOne": "previousPage", // method with the name "previousPage" must be defined in the global space
                        "performActionTwo": "nextPage" // method with the name "nextPage" must be defined in the global space
                    }
                },
                {
                    "name": "tableRegionParents", // TODO: make this the default table template
                    "template": "#table-template",
                    "fields": [
                        { "data": "parents", "names": [ "sarahEdiId", "partNumber", "description", "attributes.creationDate" ] }
                    ],
                    "viewType": "CompositeView",
                    "multiple": "true",
                    "childViewContainer": ".table-body",
                    "parentFields": [
                        { "name": "type" },
                        {
                            "name": "headers",
                            "value": [ ] // Default: get the value of the table headers from field names in the "fields.names" attribute
                        },
                        { "name": "total", "value": null }
                    ],
                    "sortOn" : [ "attributes.creationDate" ],
                    "childView": {
                        "template": "#table-row-template",
                        "tagName": "tr",
                        "className": "table-row clickable",
                        "viewType": "ItemView"
                    },
                    "additionalFields": [
                        { "name": "page", "value": 1},
                        { "name": "start", "value": 1 },
                        { "name": "end", "value": 20 },
                        { "name": "itemsPerPage", "value": 20 }
                    ],
                    "events": {
                        "click .clickable": "performActionOne",
                        "click .sortable": "performActionTwo"
                    },
                    "hash": {
                        "performActionOne": "clickRow",
                        "performActionTwo": "clickSort"
                    }
                },
                {
                    "name": "tableHeaderRegionSiblings",
                    "template": "#table-header-template",
                    "fields": [
                        { "data": "metadata", "names": [ "_type" ] },
                        { "data": "siblings", "names": [ "total" ] }
                    ],
                    "viewType": "ItemView",
                    "additionalFields": [
                        { "name": "table_type", "value": "Siblings" },
                        { "name": "table_name", "value": "siblings" },
                        { "name": "region_name", "value": "tableRegionSiblings" }, // value must match one of the regions name field
                        { "name": "page", "value": 1 },
                        { "name": "start", "value": 1 },
                        { "name": "end", "value": 20 },
                        { "name": "itemsPerPage", "value": 20 }
                    ],
                    "triggers": {
                        "click .page-arrow.previous-page": "action:one",
                        "click .page-arrow.next-page": "action:two"
                    },
                    "events": {
                        "action:one": "performActionOne",
                        "action:two": "performActionTwo"
                    },
                    "hash": {
                        "performActionOne": "previousPage", // method with the name "previousPage" must be defined in the global space
                        "performActionTwo": "nextPage" // method with the name "nextPage" must be defined in the global space
                    }
                },
                {
                    "name": "tableRegionSiblings",
                    "template": "#table-template",
                    "fields": [
                        {
                            "data": "siblings",
                            "names": [ "sarahEdiId", "partNumber", "description", "attributes.creationDate" ]
                        }
                    ],
                    "dependsOn" : [ "metadata"], // matches "dependsOn" field in API JSON model
                    "viewType": "CompositeView",
                    "multiple": "true",
                    "childViewContainer": ".table-body",
                    "parentFields": [
                        { "name": "type" }, // type value must match one of the data types
                        {
                            "name": "headers",
                            "value": [ ] // Default: get the value of the table headers from field names in the "fields.names" attribute
                        }
                    ],
                    "sortOn" : [ "attributes.creationDate" ],
                    "childView": {
                        "template": "#table-row-template",
                        "tagName": "tr",
                        "className": "table-row clickable",
                        "viewType": "ItemView"
                    },
                    "additionalFields": [
                        { "name": "page", "value": 1},
                        { "name": "start", "value": 1 },
                        { "name": "end", "value": 20 },
                        { "name": "itemsPerPage", "value": 20 }
                    ],
                    "events": {
                        "click .clickable": "performActionOne",
                        "click .sortable": "performActionTwo"
                    },
                    "hash": {
                        "performActionOne": "clickRow",
                        "performActionTwo": "clickSort"
                    }
                },
                {
                    "name": "tableHeaderRegionComponents",
                    "template": "#table-header-template",
                    "fields": [
                        { "data": "metadata", "names": [ ] },
                        { "data": "components", "names": [ "total" ] }
                    ],
                    "viewType": "ItemView",
                    "additionalFields": [
                        { "name": "table_type", "value": "Components" },
                        { "name": "table_name", "value": "components" },
                        { "name": "region_name", "value": "tableRegionComponents" },
                        { "name": "page", "value": 1},
                        { "name": "start", "value": 1 },
                        { "name": "end", "value": 20 },
                        { "name": "itemsPerPage", "value": 20 }
                    ],
                    "triggers": {
                        "click .page-arrow.previous-page": "action:one",
                        "click .page-arrow.next-page": "action:two"
                    },
                    "events": {
                        "action:one": "performActionOne",
                        "action:two": "performActionTwo"
                    },
                    "hash": {
                        "performActionOne": "previousPage", // method with the name "previousPage" must be defined in the global space
                        "performActionTwo": "nextPage" // method with the name "nextPage" must be defined in the global space
                    }
                },
                {
                    "name": "tableRegionComponents",
                    "template": "#table-template",
                    "fields": [
                        {   "data": "components",
                            "names": [ "sarahEdiId", "itemNumber", "serialNumber", "description", "indexed", "attributes.acquiredDate" ]
                        }
                    ],
                    "viewType": "CompositeView",
                    "multiple": "true",
                    "childViewContainer": ".table-body",
                    "parentFields": [
                        { "name": "type", "value": "data" }, // type value must match the View model fields.data value for this region
                        {
                            "name": "headers",
                            "value": [ ] // Default: get the value of the table headers from field names in the "fields.names" attribute
                        }
                    ],
                    "sortOn" : [ "indexed", "attributes.acquiredDate" ],
                    "childView": {
                        "template": "#table-row-template",
                        "tagName": "tr",
                        "className": "table-row clickable",
                        "viewType": "ItemView"
                    },
                    "additionalFields": [
                        { "name": "page", "value": 1},
                        { "name": "start", "value": 1 },
                        { "name": "end", "value": 20 },
                        { "name": "itemsPerPage", "value": 20 }
                    ],
                    "events": {
                        "click .clickable": "performActionOne",
                        "click .sortable": "performActionTwo"
                    },
                    "hash": {
                        "performActionOne": "clickRow",
                        "performActionTwo": "clickSort"
                    }
                }
                ,
                {
                    "name": "tableHeaderRegionChildren",
                    "template": "#table-header-template",
                    "fields": [
                        {
                            "data": "metadata",
                            "names": [ "_type" ],
                            "values": [  // optional field values that match required template parameters
                                {
                                    "name": "total", // name of the field in the template
                                    "field": "bill", // name of the data field in JSON model
                                    "value": "length" // field value to get
                                }
                            ]
                        }
                    ],
                    "viewType": "ItemView",
                    "additionalFields": [
                        { "name": "table_type", "value": "Children / Bill of Materials" },
                        { "name": "table_name", "value": "children" },
                        { "name": "region_name", "value": "tableRegionChildren" }, // value must match one of the regions name field
                        { "name": "page", "value": 1 },
                        { "name": "start", "value": 1 },
                        { "name": "end", "value": 20 },
                        { "name": "itemsPerPage", "value": 20 }
                    ],
                    "triggers": {
                        "click .page-arrow.previous-page": "action:one",
                        "click .page-arrow.next-page": "action:two"
                    },
                    "events": {
                        "action:one": "performActionOne",
                        "action:two": "performActionTwo"
                    },
                    "hash": {
                        "performActionOne": "previousPage", // method with the name "previousPage" must be defined in the global space
                        "performActionTwo": "nextPage" // method with the name "nextPage" must be defined in the global space
                    }
                },
                {
                    "name": "tableRegionChildren",
                    "template": "#table-template",
                    "fields": [
                        {
                            "data": "metadata",
                            "names": [ "bill.sarahEdiId", "bill.itemNumber", "bill.description", "bill.quantityPer" ] // names match field names in JSON data model
                        }
                    ],
                    "viewType": "CompositeView",
                    "multiple": "true",
                    "nested": "true",
                    "childViewContainer": ".table-body",
                    "parentFields": [ // required for a table template
                        { "name": "type" },
                        {
                            "name": "headers",
                            "value": [ ] // Default: get the value of the table headers from field names in the "fields.names" or "fields.values" attribute
                        }
                    ],
                    "childView": {
                        "template": "#table-row-template",
                        "tagName": "tr",
                        "className": "table-row clickable",
                        "viewType": "ItemView"
                    },
                    "additionalFields": [
                        { "name": "page", "value": 1},
                        { "name": "start", "value": 1 },
                        { "name": "end", "value": 20 },
                        { "name": "itemsPerPage", "value": 20 }
                    ],
                    "events": {
                        "click .clickable": "performActionOne"
                    },
                    "hash": {
                        "performActionOne": "clickRow"
                    }
                },
                {
                    "name": "tableHeaderRegionLinks",
                    "template": "#table-header-template",
                    "fields": [
                        { "data": "metadata", "names": [ ] },
                        { "data": "documents", "names": [ "total" ] }
                    ],
                    "viewType": "ItemView",
                    "additionalFields": [
                        { "name": "table_type", "value": "Linked Documents" },
                        { "name": "table_name", "value": "documents" },
                        { "name": "region_name", "value": "tableRegionLinks" }, // value must match one of the regions name field
                        { "name": "page", "value": 1}, // make default
                        { "name": "start", "value": 1 }, // make default
                        { "name": "end", "value": 20 }, // make default
                        { "name": "itemsPerPage", "value": 20 }
                    ],
                    "triggers": { // make default
                        "click .page-arrow.previous-page": "action:one",
                        "click .page-arrow.next-page": "action:two"
                    },
                    "events": { // make default
                        "action:one": "performActionOne",
                        "action:two": "performActionTwo"
                    },
                    "hash": { // make default
                        "performActionOne": "previousPage", // method with the name "previousPage" must be defined in the global space
                        "performActionTwo": "nextPage" // method with the name "nextPage" must be defined in the global space
                    }
                },
                {
                    "name": "tableRegionLinks",
                    "template": "#table-template", // make this default
                    "fields": [
                        {
                            "data": "documents",
                            "names": [ "edi_type", "asaIdentifier", "title", "delta_ts", "creation_ts" ], // names must match field names in the data JSON model (data that's coming from the server)
                            "multiple": true
                        }
                    ],
                    "viewType": "CompositeView", // make this default
                    "multiple": "true", // make this default
                    "childViewContainer": ".table-body", // make this default
                    "parentFields": [
                        { "name": "type", "value": "document" },
                        {
                            "name": "headers",
                            "value": [ ] // Default: get the value of the table headers from field names in the "fields.names" attribute
                        }
                    ],
                    "sortOn": [ "delta_ts", "creation_ts" ],
                    "childView": { // make this default
                        "template": "#table-row-template",
                        "tagName": "tr",
                        "className": "table-row clickable",
                        "viewType": "ItemView"
                    },
                    "additionalFields": [
                        { "name": "page", "value": 1},
                        { "name": "start", "value": 1 },
                        { "name": "end", "value": 20 },
                        { "name": "itemsPerPage", "value": 20 }
                    ],
                    "events": {
                        "click .sortable": "performActionOne",
                        "click .clickable": "performActionTwo"
                    },
                    "hash": {
                        "performActionOne": "clickSort",
                        "performActionTwo": "clickRow"
                    }
                }
            ]
        }
    ]
};

/**
 * JSON model representing Backbone.Marionette views and what data to render in what region and template
 */
var ComponentViewModel = {
    "properties": [
        {
            "page": "record", // page name
            "regions": [
                {
                    "name": "headerRegion", // matches one of the region names in the LayoutModel
                    "template": "#custom-header-template", // matches one of the existing templates
                    "fields": [
                        {
                            "data": "metadata", // "data" field matches one of the names in the APIModel
                            "names": [ "_type", "title" ] // Field "names" match field names in the data JSON model
                        }
                    ],
                    "viewType": "ItemView" // Backbone.Marionette view type (ItemView renders a model)
                },
                {
                    "name": "treeRegion",
                    "template": "#tree-template",
                    "fields": [
                        { "data": "metadata", "names": [ "bill" ] },
                        { "data": "parents", "names": [ "_id", "itemNumber", "title" ] },
                        { "data": "siblings", "names": [ "_id", "itemNumber", "title" ] }
                    ],
                    "viewType": "ItemView",
                    "graph": "true"
                },
                {
                    "name": "accordionRegionGeneral", // TODO: make this the default accordion template
                    "template": "#accordion-template",
                    "fields": [
                        { "data": "metadata", "names": [ "all" ] }
                    ],
                    "viewType": "CompositeView", // CompositeView renders both a collection and a model
                    "nested": "true", // signifies that the data for this region is in a nested object
                    "childViewContainer": ".panel-body",
                    "parentFields": [ // parentFields is the data that is necessary for display but does not come from the JSON Model or the APIModel
                        { "name": "title", "value": "General Information" },
                        { "name": "id", "value": "generalInfo" }
                    ],
                    "childView": { // CompositeView needs a childView (view for models inside the collection)
                        "template": "#accordion-child-template", // child model view template id
                        "tagName": "div", // child model view wrapping element
                        "className": "full-row record-row", // child model wrapping element's class name
                        "viewType": "ItemView" // child model view type
                    },
                    "events": {
                        "click .accordion-button": "performActionOne"
                    },
                    "hash": {
                        "performActionOne": "wrapperAccordionIconClick"
                    }
                },
                {
                    "name": "accordionRegionAttributes",
                    "template": "#accordion-template",
                    "fields": [
                        { "data": "metadata", "names": [ "attributes" ] }
                    ],
                    "viewType": "CompositeView",
                    "nested": "true",
                    "childViewContainer": ".panel-body",
                    "parentFields": [
                        { "name": "title", "value": "Attributes" },
                        { "name": "id", "value": "attributes" }
                    ],
                    "childView": {
                        "template": "#accordion-child-template",
                        "tagName": "div",
                        "className": "full-row record-row",
                        "viewType": "ItemView"
                    },
                    "events": {
                        "click .accordion-button": "performActionOne"
                    },
                    "hash": {
                        "performActionOne": "wrapperAccordionIconClick"
                    }
                },
                {
                    "name": "accordionRegionLimitedLife",
                    "template": "#accordion-template",
                    "fields": [
                        { "data": "metadata", "names": [ "limitedLife" ] }
                    ],
                    "viewType": "CompositeView",
                    "nested": "true",
                    "childViewContainer": ".panel-body",
                    "parentFields": [
                        { "name": "title", "value": "Limited Life" },
                        { "name": "id", "value": "limitedLife" }
                    ],
                    "childView": {
                        "template": "#accordion-child-template",
                        "tagName": "div",
                        "className": "full-row record-row",
                        "viewType": "ItemView"
                    },
                    "events": {
                        "click .accordion-button": "performActionOne"
                    },
                    "hash": {
                        "performActionOne": "wrapperAccordionIconClick"
                    }
                },
                {
                    "name": "accordionRegionPart",
                    "template": "#accordion-template",
                    "fields": [
                        {
                            "data": "part",
                            "names": [ "drawingNumber", "description", "partNumber", "title", "sarahEdiId", "attributes.hasBillOfMaterial", "attributes.creationDate", "attributes.source", "attributes.category" ]
                        }
                    ],
                    "dependsOn" : [ "metadata" ],
                    "viewType": "CompositeView",
                    "nested": "true",
                    "childViewContainer": ".panel-body",
                    "parentFields": [
                        { "name": "title", "value": "Part" },
                        { "name": "id", "value": "part" }
                    ],
                    "childView": {
                        "template": "#accordion-child-template",
                        "tagName": "div",
                        "className": "full-row record-row",
                        "viewType": "ItemView"
                    },
                    "events": {
                        "click .accordion-button": "performActionOne"
                    },
                    "hash": {
                        "performActionOne": "wrapperAccordionIconClick"
                    }
                },
                {
                    "name": "tableHeaderRegionParents",
                    "template": "#table-header-template",
                    "fields": [
                        { "data": "metadata", "names": [ "_type" ] },
                        { "data": "parents", "names": [ "total" ] }
                    ],
                    "viewType": "ItemView",
                    "additionalFields": [  // similar to parentFields in regions with a CompositeView, additionalFields is the data that is necessary for display but does not come from the JSON model or API model.
                        { "name": "table_type", "value": "Parents" },
                        { "name": "table_name", "value": "parents" },
                        { "name": "region_name", "value": "tableRegionParents" }, // value must match one of the regions name field
                        { "name": "page", "value": 1},
                        { "name": "start", "value": 1 },
                        { "name": "end", "value": 20 },
                        { "name": "itemsPerPage", "value": 20 }
                    ],
                    "triggers": {
                        "click .page-arrow.previous-page": "action:one",
                        "click .page-arrow.next-page": "action:two"
                    },
                    "events": {
                        "action:one": "performActionOne",
                        "action:two": "performActionTwo"
                    },
                    "hash": {
                        "performActionOne": "previousPage", // method with the name "previousPage" must be defined in the global space
                        "performActionTwo": "nextPage" // method with the name "nextPage" must be defined in the global space
                    }
                },
                {
                    "name": "tableRegionParents",
                    "template": "#table-template",
                    "fields": [
                        { "data": "parents", "names": [ "sarahEdiId", "itemNumber", "description", "indexed", "attributes.acquiredDate" ] }
                    ],
                    "viewType": "CompositeView",
                    "multiple": "true",
                    "childViewContainer": ".table-body",
                    "parentFields": [
                        { "name": "type", "value": "component" },
                        {
                            "name": "headers",
                            "value": [ ] // Default: get the value of the table headers from field names in the "fields.names" attribute
                        },
                        { "name": "total", "value": null }
                    ],
                    "sortOn" : [ "indexed", "attributes.acquiredDate" ],
                    "childView": {
                        "template": "#table-row-template",
                        "tagName": "tr",
                        "className": "table-row clickable",
                        "viewType": "ItemView"
                    },
                    "additionalFields": [
                        { "name": "page", "value": 1},
                        { "name": "start", "value": 1 },
                        { "name": "end", "value": 20 },
                        { "name": "itemsPerPage", "value": 20 }
                    ],
                    "events": {
                        "click .clickable": "performActionOne",
                        "click .sortable": "performActionTwo"
                    },
                    "hash": {
                        "performActionOne": "clickRow",
                        "performActionTwo": "clickSort"
                    }
                },
                {
                    "name": "tableHeaderRegionSiblings",
                    "template": "#table-header-template",
                    "fields": [
                        { "data": "metadata", "names": [ "_type" ] },
                        { "data": "siblings", "names": [ "total" ] }
                    ],
                    "viewType": "ItemView",
                    "additionalFields": [
                        { "name": "table_type", "value": "Siblings" },
                        { "name": "table_name", "value": "siblings" },
                        { "name": "region_name", "value": "tableRegionSiblings" }, // value must match one of the regions name field
                        { "name": "page", "value": 1 },
                        { "name": "start", "value": 1 },
                        { "name": "end", "value": 20 },
                        { "name": "itemsPerPage", "value": 20 }
                    ],
                    "triggers": {
                        "click .page-arrow.previous-page": "action:one",
                        "click .page-arrow.next-page": "action:two"
                    },
                    "events": {
                        "action:one": "performActionOne",
                        "action:two": "performActionTwo"
                    },
                    "hash": {
                        "performActionOne": "previousPage", // method with the name "previousPage" must be defined in the global space
                        "performActionTwo": "nextPage" // method with the name "nextPage" must be defined in the global space
                    }
                },
                {
                    "name": "tableRegionSiblings",
                    "template": "#table-template",
                    "fields": [
                        {
                            "data": "siblings",
                            "names": [ "sarahEdiId", "itemNumber", "description", "indexed", "attributes.acquiredDate" ]
                        }
                    ],
                    "dependsOn" : [ "metadata"], // matches "dependsOn" field in API JSON model
                    "viewType": "CompositeView",
                    "multiple": "true",
                    "childViewContainer": ".table-body",
                    "parentFields": [
                        { "name": "type" },
                        {
                            "name": "headers",
                            "value": [ ] // Default: get the value of the table headers from field names in the "fields.names" attribute
                        }
                    ],
                    "sortOn" : [ "indexed", "attributes.acquiredDate" ],
                    "childView": {
                        "template": "#table-row-template",
                        "tagName": "tr",
                        "className": "table-row clickable",
                        "viewType": "ItemView"
                    },
                    "additionalFields": [
                        { "name": "page", "value": 1},
                        { "name": "start", "value": 1 },
                        { "name": "end", "value": 20 },
                        { "name": "itemsPerPage", "value": 20 }
                    ],
                    "events": {
                        "click .clickable": "performActionOne",
                        "click .sortable": "performActionTwo"
                    },
                    "hash": {
                        "performActionOne": "clickRow",
                        "performActionTwo": "clickSort"
                    }
                },
                {
                    "name": "tableHeaderRegionChildren",
                    "template": "#table-header-template",
                    "fields": [
                        {
                            "data": "metadata",
                            "names": [ "_type" ],
                            "values": [  // optional field values that match required template parameters
                                {
                                    "name": "total", // name of the field in the template
                                    "field": "bill", // name of the data field in JSON model
                                    "value": "length" // field value to get
                                }
                            ]
                        }
                    ],
                    "viewType": "ItemView",
                    "additionalFields": [
                        { "name": "table_type", "value": "Children / As-Built Bill of Materials" },
                        { "name": "table_name", "value": "children" },
                        { "name": "region_name", "value": "tableRegionChildren" }, // value must match one of the regions name field
                        { "name": "page", "value": 1 },
                        { "name": "start", "value": 1 },
                        { "name": "end", "value": 20 },
                        { "name": "itemsPerPage", "value": 20 }
                    ],
                    "triggers": {
                        "click .page-arrow.previous-page": "action:one",
                        "click .page-arrow.next-page": "action:two"
                    },
                    "events": {
                        "action:one": "performActionOne",
                        "action:two": "performActionTwo"
                    },
                    "hash": {
                        "performActionOne": "previousPage", // method with the name "previousPage" must be defined in the global space
                        "performActionTwo": "nextPage" // method with the name "nextPage" must be defined in the global space
                    }
                },
                {
                    "name": "tableRegionChildren",
                    "template": "#table-template",
                    "fields": [
                        {
                            "data": "metadata",
                            "names": [ "bill.sarahEdiId", "bill.drawingNumber", "bill.description", "bill.quantityPer" ] // names match field names in JSON data model
                        }
                    ],
                    "viewType": "CompositeView",
                    "multiple": "true",
                    "nested": "true",
                    "childViewContainer": ".table-body",
                    "parentFields": [ // required for a table template
                        { "name": "type", "value": "component" },
                        {
                            "name": "headers",
                            "value": [ ] // Default: get the value of the table headers from field names in the "fields.names" or "fields.values" attribute
                        }
                    ],
                    "childView": {
                        "template": "#table-row-template",
                        "tagName": "tr",
                        "className": "table-row clickable",
                        "viewType": "ItemView"
                    },
                    "additionalFields": [
                        { "name": "page", "value": 1},
                        { "name": "start", "value": 1 },
                        { "name": "end", "value": 20 },
                        { "name": "itemsPerPage", "value": 20 }
                    ],
                    "events": {
                        "click .clickable": "performActionOne"
                    },
                    "hash": {
                        "performActionOne": "clickRow"
                    }
                },
                {
                    "name": "tableHeaderRegionLinks",
                    "template": "#table-header-template",
                    "fields": [
                        { "data": "documents", "names": [ "total" ] }
                    ],
                    "viewType": "ItemView",
                    "additionalFields": [
                        { "name": "table_type", "value": "Linked Documents" },
                        { "name": "table_name", "value": "documents" },
                        { "name": "region_name", "value": "tableRegionLinks" }, // value must match one of the regions name field
                        { "name": "page", "value": 1}, // make default
                        { "name": "start", "value": 1 }, // make default
                        { "name": "end", "value": 20 }, // make default
                        { "name": "itemsPerPage", "value": 20 }
                    ],
                    "triggers": { // make default
                        "click .page-arrow.previous-page": "action:one",
                        "click .page-arrow.next-page": "action:two"
                    },
                    "events": { // make default
                        "action:one": "performActionOne",
                        "action:two": "performActionTwo"
                    },
                    "hash": { // make default
                        "performActionOne": "previousPage", // method with the name "previousPage" must be defined in the global space
                        "performActionTwo": "nextPage" // method with the name "nextPage" must be defined in the global space
                    }
                },
                {
                    "name": "tableRegionLinks",
                    "template": "#table-template", // make this default
                    "fields": [
                        {
                            "data": "documents",
                            "names": [ "documentType", "sarahEdiId", "title", "openDate", "closeDate" ], // names must match field names in the data JSON model (data that's coming from the server)
                            "multiple": true
                        }
                    ],
                    "viewType": "CompositeView", // make this default
                    "multiple": "true", // make this default
                    "childViewContainer": ".table-body", // make this default
                    "parentFields": [
                        { "name": "type", "value": "document" },
                        {
                            "name": "headers",
                            "value": [ ] // Default: get the value of the table headers from field names in the "fields.names" attribute
                        }
                    ],
                    "sortOn": [ "openDate", "closeDate" ],
                    "childView": { // make this default
                        "template": "#table-row-template",
                        "tagName": "tr",
                        "className": "table-row clickable",
                        "viewType": "ItemView"
                    },
                    "additionalFields": [
                        { "name": "page", "value": 1},
                        { "name": "start", "value": 1 },
                        { "name": "end", "value": 20 },
                        { "name": "itemsPerPage", "value": 20 }
                    ],
                    "events": {
                        "click .sortable": "performActionOne",
                        "click .clickable": "performActionTwo"
                    },
                    "hash": {
                        "performActionOne": "clickSort",
                        "performActionTwo": "clickRow"
                    }
                },
                {
                    "name": "tableHeaderRegionEvents",
                    "template": "#table-header-template",
                    "fields": [
                        {
                            "data": "events",
                            "names": [ "total" ]
                        }
                    ],
                    "viewType": "ItemView",
                    "additionalFields": [
                        { "name": "table_type", "value": "Events" },
                        { "name": "table_name", "value": "events" },
                        { "name": "region_name", "value": "tableRegionEvents" }, // value must match one of the regions name field
                        { "name": "page", "value": 1 },
                        { "name": "start", "value": 1 },
                        { "name": "end", "value": 20 },
                        { "name": "itemsPerPage", "value": 20 }
                    ],
                    "triggers": {
                        "click .page-arrow.previous-page": "action:one",
                        "click .page-arrow.next-page": "action:two"
                    },
                    "events": {
                        "action:one": "performActionOne",
                        "action:two": "performActionTwo"
                    },
                    "hash": {
                        "performActionOne": "previousPage", // method with the name "previousPage" must be defined in the global space
                        "performActionTwo": "nextPage" // method with the name "nextPage" must be defined in the global space
                    }
                },
                {
                    "name": "tableRegionEvents",
                    "template": "#table-template", // make this default
                    "fields": [
                        {
                            "data": "events",
                            "names": [ "eventType", "sarahEdiId", "title", "status", "entryDate", "eventDate"  ] // names must match field names in the data JSON model (data that's coming from the server)
                        }
                    ],
                    "viewType": "CompositeView", // make this default
                    "multiple": "true", // make this default
                    "childViewContainer": ".table-body", // make this default
                    "parentFields": [
                        { "name": "type", "value": "data" },
                        {
                            "name": "headers",
                            "value": [ ] // Default: get the value of the table headers from field names in the "fields.names" attribute
                        }
                    ],
                    "sortOn": [ "entryDate", "eventDate" ],
                    "childView": { // make this default
                        "template": "#table-row-template",
                        "tagName": "tr",
                        "className": "table-row clickable",
                        "viewType": "ItemView"
                    },
                    "additionalFields": [
                        { "name": "page", "value": 1},
                        { "name": "start", "value": 1 },
                        { "name": "end", "value": 20 },
                        { "name": "itemsPerPage", "value": 20 }
                    ],
                    "events": {
                        "click .sortable": "performActionOne",
                        "click .clickable": "performActionTwo"
                    },
                    "hash": {
                        "performActionOne": "clickSort",
                        "performActionTwo": "clickRow"
                    }
                }
            ]
        }
    ]
};


/******************************************
 * State models : custom only, no default
 ******************************************/

/**
 * JSON model representing page global state for part records
 */
var PartPageStateModel = { // TODO create it from view model
    "properties": [
        {
            "page": "record", // page name
            "regions": [
                {
                    "name": "tableHeaderRegionChildren", // name matches region name in JSON View Model and LayoutModel
                    "variables": [ // this attribute is needed for the region changes (like pagination)
                        { "name": "page", "value": 1, "default": 1 }, // name of the variable that page keeps track of and its default value
                        { "name": "itemsPerPage", "value": 20, "default": 20 },
                        { "name": "start", "value": 1, "default": 1 },
                        { "name": "end", "value": 20, "default": 20 }
                    ]
                },
                {
                    "name": "tableHeaderRegionSiblings",
                    "variables": [ // make default for table header regions
                        { "name": "page", "value": 1, "default": 1 },
                        { "name": "itemsPerPage", "value": 20, "default": 20 },
                        { "name": "start", "value": 1, "default": 1 },
                        { "name": "end", "value": 20, "default": 20 }
                    ]
                },
                {
                    "name": "tableHeaderRegionLinks",
                    "variables": [
                        { "name": "page", "value": 1, "default": 1 },
                        { "name": "itemsPerPage", "value": 20, "default": 20 },
                        { "name": "start", "value": 1, "default": 1 },
                        { "name": "end", "value": 20, "default": 20 }
                    ]
                },
                {
                    "name": "tableHeaderRegionComponents",
                    "variables": [
                        { "name": "page", "value": 1, "default": 1 },
                        { "name": "itemsPerPage", "value": 20, "default": 20 },
                        { "name": "start", "value": 1, "default": 1 },
                        { "name": "end", "value": 20, "default": 20 }
                    ]
                },
                {
                    "name": "tableHeaderRegionParents",
                    "variables": [
                        { "name": "page", "value": 1, "default": 1 },
                        { "name": "itemsPerPage", "value": 20, "default": 20 },
                        { "name": "start", "value": 1, "default": 1 },
                        { "name": "end", "value": 20, "default": 20 }
                    ]
                },
                {
                    "name": "tableRegionParents",
                    "variables": [
                        { "name": "sortOrder", "value": null, "default": null },
                        { "name": "sortField", "value": null, "default": null }
                    ]
                },
                {
                    "name": "tableRegionSiblings",
                    "variables": [
                        { "name": "sortOrder", "value": null, "default": null },
                        { "name": "sortField", "value": null, "default": null }
                    ]
                },
                {
                    "name": "tableRegionComponents",
                    "variables": [
                        { "name": "sortOrder", "value": null, "default": null },
                        { "name": "sortField", "value": null, "default": null }
                    ]
                },
                {
                    "name": "tableRegionLinks",
                    "variables": [
                        { "name": "sortOrder", "value": null, "default": null },
                        { "name": "sortField", "value": null, "default": null }
                    ]
                },
                {
                    "name": "graphRegion",
                    "variables": [
                        { "name": "traversalHistory", "value": [], "default": [] }, // array of id of visited nodes
                        { "name": "itemsPerPage", "value": 20, "default": 20 }, // maximum number of nodes per graph side shown
                        {
                            "name" : "left", // name of the graph side, must match the display name in region view JSON model
                            "value": [
                                { "name": "page", "value": 1, "default": 1 }, // left side page number of data shown
                                { "name": "total", "value": 0, "default": 0 },  // total number of nodes on the left side
                                { "name": "data", "value": null, "default": null }, // current left side array of nodes
                                { "name": "sortOrder", "value": null, "default": null }, // sort order of the data
                                { "name": "sortField", "value": null, "default": null } // sort field
                            ],
                            "default": [
                                { "name": "page", "value": 1, "default": 1 }, // left side default page number
                                { "name": "total", "value": 0, "default": 0 },  // default total number of nodes on the left side
                                { "name": "data", "value": null, "default": null }, // default left side array of nodes
                                { "name": "sortOrder", "value": null, "default": null }, // default sort order of the data
                                { "name": "sortField", "value": null, "default": null } // default sort field
                            ]
                        },
                        {
                            "name": "middle",
                            "value": [
                                { "name": "page", "value": 1, "default": 1 }, // right side page number of data shown
                                { "name": "total", "value": 0, "default": 0 },  // total number of nodes on the right side
                                { "name": "data", "value": null, "default": null }, // current right side array of nodes
                                { "name": "sortOrder", "value": null, "default": null },
                                { "name": "sortField", "value": null, "default": null }
                            ],
                            "default": [
                                { "name": "page", "value": 1, "default": 1 },
                                { "name": "total", "value": 0, "default": 0 },
                                { "name": "data", "value": null, "default": null },
                                { "name": "sortOrder", "value": null, "default": null },
                                { "name": "sortField", "value": null, "default": null }
                            ]
                        },
                        {
                            "name": "right",
                            "value": [
                                { "name": "page", "value": 1, "default": 1 }, // right side page number of data shown
                                { "name": "total", "value": 0, "default": 0 },  // total number of nodes on the right side
                                { "name": "data", "value": null, "default": null } // current right side array of nodes
                            ],
                            "default": [
                                { "name": "page", "value": 1, "default": 1 },
                                { "name": "total", "value": 0, "default": 0 },
                                { "name": "data", "value": null, "default": null }
                            ]
                        }
                    ]
                }
            ]
        }
    ]
};

/**
 * JSON model representing page global state for part records
 */
var ComponentPageStateModel = { // TODO create it from view model
    "properties": [
        {
            "page": "record", // page name
            "regions": [
                {
                    "name": "tableHeaderRegionChildren", // name matches region name in JSON View Model and LayoutModel
                    "variables": [ // this attribute is needed for the region changes (like pagination)
                        { "name": "page", "value": 1, "default": 1 }, // name of the variable that page keeps track of and its default value
                        { "name": "itemsPerPage", "value": 20, "default": 20 },
                        { "name": "start", "value": 1, "default": 1 },
                        { "name": "end", "value": 20, "default": 20 }
                    ]
                },
                {
                    "name": "tableHeaderRegionSiblings",
                    "variables": [ // make default for table header regions
                        { "name": "page", "value": 1, "default": 1 },
                        { "name": "itemsPerPage", "value": 20, "default": 20 },
                        { "name": "start", "value": 1, "default": 1 },
                        { "name": "end", "value": 20, "default": 20 }
                    ]
                },
                {
                    "name": "tableHeaderRegionLinks",
                    "variables": [
                        { "name": "page", "value": 1, "default": 1 },
                        { "name": "itemsPerPage", "value": 20, "default": 20 },
                        { "name": "start", "value": 1, "default": 1 },
                        { "name": "end", "value": 20, "default": 20 }
                    ]
                },
                {
                    "name": "tableHeaderRegionParents",
                    "variables": [
                        { "name": "page", "value": 1, "default": 1 },
                        { "name": "itemsPerPage", "value": 20, "default": 20 },
                        { "name": "start", "value": 1, "default": 1 },
                        { "name": "end", "value": 20, "default": 20 }
                    ]
                },
                {
                    "name": "tableHeaderRegionEvents",
                    "variables": [
                        { "name": "page", "value": 1, "default": 1 },
                        { "name": "itemsPerPage", "value": 20, "default": 20 },
                        { "name": "start", "value": 1, "default": 1 },
                        { "name": "end", "value": 20, "default": 20 }
                    ]
                },
                {
                    "name": "tableRegionParents",
                    "variables": [
                        { "name": "sortOrder", "value": null, "default": null },
                        { "name": "sortField", "value": null, "default": null }
                    ]
                },
                {
                    "name": "tableRegionSiblings",
                    "variables": [
                        { "name": "sortOrder", "value": null, "default": null },
                        { "name": "sortField", "value": null, "default": null }
                    ]
                },
                {
                    "name": "tableRegionLinks",
                    "variables": [
                        { "name": "sortOrder", "value": null, "default": null },
                        { "name": "sortField", "value": null, "default": null }
                    ]
                },
                {
                    "name": "tableRegionEvents",
                    "variables": [
                        { "name": "sortOrder", "value": null, "default": null },
                        { "name": "sortField", "value": null, "default": null }
                    ]
                },
                {
                    "name": "graphRegion",
                    "variables": [
                        { "name": "traversalHistory", "value": [], "default": [] }, // array of id of visited nodes
                        { "name": "itemsPerPage", "value": 20, "default": 20 }, // maximum number of nodes per graph side shown
                        {
                            "name" : "left", // name of the graph side, must match the display name in region view JSON model
                            "value": [
                                { "name": "page", "value": 1, "default": 1 }, // left side page number of data shown
                                { "name": "total", "value": 0, "default": 0 },  // total number of nodes on the left side
                                { "name": "data", "value": null, "default": null }, // current left side array of nodes
                                { "name": "sortOrder", "value": null, "default": null }, // sort order of the data
                                { "name": "sortField", "value": null, "default": null } // sort field
                            ],
                            "default": [
                                { "name": "page", "value": 1, "default": 1 }, // left side default page number
                                { "name": "total", "value": 0, "default": 0 },  // default total number of nodes on the left side
                                { "name": "data", "value": null, "default": null }, // default left side array of nodes
                                { "name": "sortOrder", "value": null, "default": null }, // default sort order of the data
                                { "name": "sortField", "value": null, "default": null } // default sort field
                            ]
                        },
                        {
                            "name": "middle",
                            "value": [
                                { "name": "page", "value": 1, "default": 1 }, // right side page number of data shown
                                { "name": "total", "value": 0, "default": 0 },  // total number of nodes on the right side
                                { "name": "data", "value": null, "default": null }, // current right side array of nodes
                                { "name": "sortOrder", "value": null, "default": null },
                                { "name": "sortField", "value": null, "default": null }
                            ],
                            "default": [
                                { "name": "page", "value": 1, "default": 1 },
                                { "name": "total", "value": 0, "default": 0 },
                                { "name": "data", "value": null, "default": null },
                                { "name": "sortOrder", "value": null, "default": null },
                                { "name": "sortField", "value": null, "default": null }
                            ]
                        },
                        {
                            "name": "right",
                            "value": [
                                { "name": "page", "value": 1, "default": 1 }, // right side page number of data shown
                                { "name": "total", "value": 0, "default": 0 },  // total number of nodes on the right side
                                { "name": "data", "value": null, "default": null } // current right side array of nodes
                            ],
                            "default": [
                                { "name": "page", "value": 1, "default": 1 },
                                { "name": "total", "value": 0, "default": 0 },
                                { "name": "data", "value": null, "default": null }
                            ]
                        }
                    ]
                }
            ]
        }
    ]
};

/****
 Search models
 */
var CatalogSearchModel = {
    "properties":[
        {
            "properties": [
                {"label": "Allowed groups/users", "name": "ACL_ALLOW", "type": "string", "multiple": "true"},
                {"label": "Denied groups/users", "name": "ACL_DENY", "type": "string", "multiple": "true"},
                {"label": "All text", "name": "all_text", "type": "string"},
                {"label": "CRDB Record Id", "name": "CRDB_RECORD_ID", "type": "string"},
                {"label": "Title", "name": "title", "type": "string"}
            ]
        }
    ]
};